module.exports = __webpack_public_path__ + "static/media/caveman.ee3f5a5b.svg";